var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import TabTrap from '../../../helpers/TabTrap';
import { ModalWrapper, Overlay, StyledFooter } from './subcomponents';
const SimpleModalPortal = (_a) => {
    var { id, children, header, className, footerButtons, isOpen, escapeModalHandler, containerId, onCloseTransitionEnd = () => { } } = _a, props = __rest(_a, ["id", "children", "header", "className", "footerButtons", "isOpen", "escapeModalHandler", "containerId", "onCloseTransitionEnd"]);
    const TRANSITION_DURATION = 250;
    const [postAnimationState, setPostAnimationState] = useState(false);
    const parentElement = document.getElementById(containerId) || document.body;
    const modalRef = useRef(null);
    useEffect(() => {
        const modal = document.getElementById(id);
        if (isOpen && !postAnimationState) {
            modal.style.transform = 'translate(-50%, -25%)';
            modal.style.opacity = '1';
            setPostAnimationState(true);
            return () => { };
        }
        if (!isOpen && postAnimationState) {
            if (modal) {
                modal.style.transform = 'translate(-50%, -60%)';
                modal.style.opacity = '0';
            }
            const timerId = setTimeout(() => {
                setPostAnimationState(false);
                onCloseTransitionEnd();
            }, TRANSITION_DURATION);
            return () => {
                clearTimeout(timerId);
            };
        }
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    return createPortal(React.createElement(Overlay, { isOpen: postAnimationState, onClick: (event) => {
            if (modalRef.current &&
                !modalRef.current.contains(event.target)) {
                escapeModalHandler();
            }
        } }, (isOpen || postAnimationState) && (React.createElement(TabTrap, null,
        React.createElement(ModalWrapper, Object.assign({}, props, { id: id, escapeModalHandler: escapeModalHandler, "aria-hidden": !isOpen, className: className, transitionDuration: TRANSITION_DURATION, modalRef: modalRef }),
            !!header && header,
            children,
            footerButtons && (React.createElement(StyledFooter, { "$shouldAlignCenter": footerButtons.length === 1 }, footerButtons)))))), parentElement);
};
export default SimpleModalPortal;
